import { useEffect } from 'react';
import { useAuthStore } from '../model/auth.store';
import { setupAuthStoreEventListeners } from '../lib/auth-store-events';

/**
 * Hook to setup auth event listeners
 * This should be called once at the app level
 */
export function useAuthEvents() {
  useEffect(() => {
    // Setup auth store event listeners
    const cleanupAuth = setupAuthStoreEventListeners(useAuthStore.setState);

    // Cleanup on unmount
    return () => {
      cleanupAuth();
    };
  }, []);
}
